module.exports = __webpack_public_path__ + "static/media/logo-marchica.8001f3ab.jpg";